var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"index"},[_c('div',{staticClass:"page-head"},[_c('the-head')],1),_c('div',{staticClass:"router-view-box"},[_c('router-view')],1),_c('div',{staticClass:"page-foot"},[_c('the-foot')],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }